import { Component, OnInit } from '@angular/core';
import { LoginService } from '../shared/services/login.service';
import { UserRole } from '../shared/models/user-role.enum';
import { ApplicationFilesService } from '../shared/services/application-files.service';
import { environment } from '@env';

interface NavItem {
  label: string;
  route?: string;
  queryParams?: { [key: string]: string };
  downloadPath?: string;
  children?: NavItem[];
  expanded?: boolean;
}

@Component({
  selector: 'ins-left-side-nav',
  templateUrl: './left-side-nav.component.html',
  styleUrls: ['./left-side-nav.component.scss'],
})
export class LeftSideNavComponent implements OnInit {
  navItems: NavItem[] = [];

  private agentNavItems: NavItem[] = [
    { label: 'Overview', route: '/agent/dashboard' },
    { label: 'Insurance Rates', route: '/agent/insurance-rates' },
    { label: 'Features And Benefits', route: '/agent/features-benefits' },
    { label: 'Excel Quote Tool', downloadPath: 'Agent\\CSI PIVQUOTE.xlsm' },
    {
      label: 'Excel Prorate Tool',
      downloadPath: 'Agent\\Prorate Calculator Agent Use.xls',
    },
    ...(environment.EnableQuoteFeature
      ? [{ label: 'Quote', route: '/quote' }]
      : []),
    { label: 'Reports', route: '/agent/reports' },
    { label: 'Underwriting Manual', route: '/agent/underwriting-manual' },
    { label: 'Renewal Attachments', route: '/agent/renewal-attachments' },
    { label: 'Monthly Renewal Request', route: '/agent/monthly-renewal' },
    { label: 'Bulletins', route: '/agent/bulletins' },
    { label: 'General Information', route: '/agent/general-information' },
  ];

  private adminNavItems: NavItem[] = [
    {
      label: 'Submitted Claims',
      route: '/admin/claims',
      queryParams: { status: 'Active' },
    },
    {
      label: 'Archived Claims',
      route: '/admin/claims',
      queryParams: { status: 'Archived' },
    },
    {
      label: 'User Management',
      route: '/admin/user-management',
    },
    {
      label: 'Admin Options',
      children: [
        { label: 'Banner Management', route: '/admin/banner-management' },
      ],
    },
  ];

  private customerNavItems: NavItem[] = [
    { label: 'Dashboard', route: '/customer/dashboard' },
    { label: 'Start A Claim', route: '/customer/start-a-claim' },
  ];

  constructor(
    private loginService: LoginService,
    private applicationFilesService: ApplicationFilesService,
  ) {}

  ngOnInit(): void {
    const roles = this.loginService.getUserRoles();
    if (roles.includes(UserRole.Admin)) {
      this.navItems = this.adminNavItems;
    } else if (roles.includes(UserRole.Customer)) {
      this.navItems = this.customerNavItems;
    } else {
      this.navItems = this.agentNavItems;
    }
  }

  onDownload(item: NavItem): void {
    if (item.downloadPath) {
      this.applicationFilesService.downloadFile(item.downloadPath);
    }
  }
}
